import { Column, CreateDateColumn, Entity, UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn, ManyToOne, JoinColumn } from "typeorm";
import { ItemSubCategory } from "../item-sub-categories/item-sub-category.entity";

@Entity('types')
export class Types {
    @PrimaryGeneratedColumn("increment", { name: 'type_id' })
    typeId: number;

    @Column("varchar", {
        nullable: false,
        name: "type"
    })
    type: string;
  
    @Column("int", {
        nullable: false,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default: 1,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    createdAt: Date;

  
}